import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from '@app/components/button/button.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { ModalSleepHoursComponent } from '@app/components/blocks/block-lifemap/modalSleepHours/modalSleepHours.component';
import { PlTimepickerModule } from '@app/components/pl-timepicker/pl-timepicker.module';

@NgModule({
  imports: [
    ButtonModule,
    CommonModule,
    FormsModule,
    MatDialogModule,
    PlIconModule,
    TranslateModule,
    PlTimepickerModule,
    ReactiveFormsModule,
  ],
  declarations: [ModalSleepHoursComponent],
  exports: [ModalSleepHoursComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ModalSleepHoursModule {}
